import { Select, MenuItem, Typography, Stack } from '@mui/material';
import { Intensity } from '@/models/intensity';
import { filterBodyzones } from '@/utils/bodyzone-filter';
import { useBodyZoneListQuery } from '@/hooks/query-hooks';
import { ExerciseDraft } from '../useExerciseEditor';

export const SimpleTagConfiguration = (props: { exercise: ExerciseDraft; updateExercise: (exercise: Partial<ExerciseDraft>) => void }) => {
  const { updateExercise } = props;
  const { bodyZoneList } = useBodyZoneListQuery();

  return (
    <Stack sx={{ alignItems: 'center', gap: 2 }} direction={'row'}>
      <Typography>Zone</Typography>
      <Select sx={{ my: 1 }} value={props.exercise.mainBodyZoneId ?? ''} displayEmpty>
        <MenuItem value="">Not Selected</MenuItem>
        {filterBodyzones(bodyZoneList ?? []).map((z, i) => (
          <MenuItem
            key={i}
            value={z.id}
            onClick={(e) => {
              if (props.exercise) {
                updateExercise({ mainBodyZoneId: z.id, muscleIntensities: z.zoneTagIds.map((tid) => ({ muscleId: tid, intensity: Intensity.medium })) });
              }
            }}
          >
            {z.name}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};
